module.exports = __webpack_public_path__ + "static/media/green_pattern.ae0efc57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/green_pattern.svg
// module id = 751
// module chunks = 0